import { NotificationEntityType } from "@interfaces/notification";

/**
 * Las rutas reales de detalle de solicitud son `/solicitud/:companyName/:id`
 * (v1) y `/v2/solicitud/:companyName/:id` (v2) — no existen rutas propias
 * para "document" ni "stage" (ver src/features/Solicitud/routes/*.tsx), así
 * que ambos tipos resuelven al mismo detalle de solicitud. `companyName` no
 * viene en las columnas de la notificación: el fan-out debe incluir
 * `company_name` dentro de `payload` para que el deep link funcione.
 */
export function resolveEntityRoute(
    entityType: NotificationEntityType | null,
    entityId: string | null,
    payload: Record<string, unknown>,
    currentPathname: string,
): string | null {
    if (!entityType || !entityId) return null;

    const companyName = payload.company_name;
    if (typeof companyName !== "string" || !companyName) return null;

    const isV2 = currentPathname.startsWith("/v2/");

    switch (entityType) {
        case "request":
        case "document":
        case "stage":
            return isV2
                ? `/v2/solicitud/${companyName}/${payload.folio}`
                : `/solicitud/${companyName}/${payload.folio}`;
        default:
            return null;
    }
}
